module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "CHAPTER_I"
    }
  }, [_vm._v("CHAPTER I"), _c('br', {
    staticClass: "calibre4"
  }), _vm._v(" "), _c('span', {
    staticClass: "fs3"
  }, [_vm._v("THE RUNAWAY HORSE")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny Brown stood behind a long board\nwhich was laid across two boxes in the front\nyard. On the board were some piles of white\nstones and little heaps of red pebbles. There\nwere also clam shells, a few filled with white\nsand and others with brown sand.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("On one end of the board were some pieces\nof paper cut into squares and near them was a\nball of string. On the other end of the board,\nbalanced on a small box, was a shingle. This\nshingle moved up and down like the scales in\na grocery store. In fact, this shingle and the\nbox were Bunny Brown’s scale. He was\n“playing store.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_2",
      "title": "[Pg 2]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Well, I wonder if anybody is coming to\nbuy anything at my store to-day,” said Bunny,\nas he paced up and down behind the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Just then a little girl, carrying a doll under\none arm, walked up to the shade tree under\nwhich the play store was. She went to the\ncounter and looked at the piles of sand, pebbles,\nand the clam shells. But Bunny Brown\ndid not seem to think she was a little girl. He\nbowed to her and asked:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“What will it be to-day, Mrs. Anderson?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, Bunny! You sound just like Mr. Gordon\nin the real grocery store!” laughed Sue,\nclapping her hands. As she did this her doll\nfell down on the grass. “You’re just like Mr.\nGordon!” cried the little girl again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny Brown frowned, wrinkling his forehead\nuntil it looked like a wash-board from\nthe laundry.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Look here!” he exclaimed, coming out\nfrom behind the counter. “I’m not going to\nplay store if you do that!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Do what?” asked Sue, for it was Bunny\nBrown’s sister Sue who had come to the store.\nBunny had called her “Mrs. Anderson,” but"), _c('span', {
    attrs: {
      "id": "Page_3",
      "title": "[Pg 3]"
    }
  }), _vm._v("\nall the same, she was Sue Brown. “What did\nI do, Bunny?” asked Sue.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“There you go again!” cried Bunny. “Stop\ncalling me by my right name! If we’re going\nto play store I’m Mr. Gordon and you’re Mrs.\nAnderson!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes, I know, Bunny, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, will you stop it?” cried the little boy,\ndancing up and down in his excitement. “I’m\nMr. Gordon keeping the store!” he explained.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes, I know you are,” admitted Sue. “I\nsaid you sounded just like Mr. Gordon when\nmother goes in and he says what will it be to-day,\nMrs. Brown. You sounded just like him,\nand—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Well, then, you must call me Mr. Gordon!”\ninsisted Bunny. “Now start over again.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, all right, Bun—I mean Mr. Gordon!”\nand Sue quickly corrected herself. “Wait a\nminute.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("She picked up her doll from the grass and,\nimitating as nearly as she could the manner\nof a grown woman, walked out of the store.\nOf course the store was out of doors, in the\nfront yard of the Brown home, under the"), _c('span', {
    attrs: {
      "id": "Page_4",
      "title": "[Pg 4]"
    }
  }), _vm._v("\ntrees. But to Bunny the store was very real,\nindeed. Bunny could “pretend” much harder\nthan could Sue, because, possibly, he was a\nyear older.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Sue—or Mrs. Anderson—having gone out,\nturned about to come in again. Bunny was\nonce more behind the counter, looking at the\nclam shells, the piles of pebbles, and the sand,\nat his wrapping paper and twine and at the\nswaying shingle on a box—his scales.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Good morning, Mrs. Anderson, what will\nit be to-day?” again asked the little boy storekeeper\nas he bowed to his sister.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, good morning, Mr. Gordon,” replied\nSue, and she did not even smile as she gave\nher brother the pretend name. This showed\nthat Sue was now playing the game in real\nearnest. “Have you any sugar this morning,\nMr. Gordon?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes, Mrs. Anderson, I have some nice\nfresh sugar that just came in,” Bunny answered,\nacting so much like Mr. Gordon, the\nreal grocer, that Sue nearly smiled at him.\nBut she remembered just in time and her face\ngrew serious.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_5",
      "title": "[Pg 5]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Do you wish white sugar or brown, Mrs.\nAnderson?” asked Bunny. I can call him that\nwithout getting into trouble, you know.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I’ll have a pound of white sugar, and two\npounds of brown,” answered Sue, or Mrs.\nAnderson.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Please have a seat while I weigh it for\nyou,” the little storekeeper went on.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("In front of the counter there was a small\nbox. Pretending that this was a stool, such\nas they sometimes have in real stores, Sue sat\ndown on it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Then Bunny, taking up a stone for a weight,\nput it on one end of the shingle scales. On\nthe other end of the shingle he piled up some\nwhite sand, and when the shingle balanced,\nthat was a pound. He put the white sand in\none of the pieces of paper and tied a string\naround it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“There is your white sugar, Mrs. Anderson,”\nhe said to his sister. Sue took it but\ncried:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, Bunny, there’s a hole in the paper and\nall the sand is running out! Look!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny Brown raised his hands in the air.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_6",
      "title": "[Pg 6]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“There you go again!” he cried. “Didn’t\nI tell you to call me Mr. Gordon and not\nBunny? And that isn’t sand—it’s sugar! If\nyou aren’t going to play right—”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, Bunny—I mean Mr. Gordon—I forgot!”\ngasped Sue. “Truly, I did! Come on\nand play!” she begged, for Bunny started to\nwalk out from behind the counter. “I won’t\ndo it again! Really, I won’t, Bun—I mean\nMr. Gordon! And I don’t care if this san—I\nmean if the sugar spills. I have lots of\nmoney and I can buy more,” and she looked\nin her pocket where a mass of green leaves\nfrom the lilac bush took the place of money.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Well, all right,” said Bunny slowly, after\na moment. “But if you forget again I’m not\ngoing to play!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I won’t forget,” promised Sue.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("She placed the paper of sand-sugar down on\nthe counter in front of her, brushed some of\nthe grains off her doll’s dress and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Now I’ll have some brown sugar, Mr.\nGordon.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Yes, Mrs. Anderson,” said Bunny. “This\nbrown sugar is very sweet. Just taste it!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_7",
      "title": "[Pg 7]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("He held some of the brown sand out to his\nsister. She looked at him in a funny way, and\nBunny cried:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Go on—taste it!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Thereupon Sue wet the end of her finger\nand dipped it in the sand Bunny held out to\nher on the end of a little board. Then Sue\nput the sand on the tip of her tongue.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Burr-r-r! Ugh! Oh, yes, it is very sweet\nsugar!” she exclaimed, making a funny face\nas she spluttered until the sand was out of her\nmouth. “I think I’ll have two pounds of that,\nMr. Gordon.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny never smiled at the funny face his\nsister made when she tasted the sand. When\nBunny played anything he was very much in\nearnest, as I have told you.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("He put another stone on the weight end of\nthe shingle scale. He then dipped out twice\nas much brown sand as he had of the white\nand wrapped this up in a paper which he tied\nwith a piece of string.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“There is the brown sugar, Mrs. Anderson,”\nhe said. “And now what else will there\nbe to-day?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_8",
      "title": "[Pg 8]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny Brown acted so much like Sam Gordon,\nthe real grocer, and even imitated his\ntalk and manners so well, that Sue felt like\nlaughing. But she knew that if she did so her\nbrother would not play any more, so she kept\nas straight a face as she could and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Have you any fresh eggs, Mr. Gordon?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, yes, Mrs. Anderson, some very fresh\nones. They were picked just this morning!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, Bunny Brown, you don’t pick eggs!\nThey grow in the chicken coop!” giggled Sue.\nAnd Bunny, knowing that he had made a mistake,\ndid not find fault this time with Sue for\ncalling him Bunny instead of Mr. Gordon.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I mean,” corrected the little boy, “that the\neggs were laid fresh this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Then I’ll take a dozen,” said Sue, getting\nher face straight again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny picked up twelve of the larger white\npebbles and put these in an old cracker box,\nof which he had several under the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Be careful not to break the eggs, Mrs. Anderson,”\nhe said, handing Sue the box. “Is\nthere anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I think that’s all,” said Sue gravely, as she"), _c('span', {
    attrs: {
      "id": "Page_9",
      "title": "[Pg 9]"
    }
  }), _vm._v("\nhad heard her mother say. “How much is\nit?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny pretended to be adding up the cost\nof the pound of white sand-sugar, the two\npounds of the brown sand-sugar, and the price\nof the dozen white-pebble-eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“That’s a dollar and fifty-seven cents,” he\nfinally said.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Sue took out a large green leaf and two\nsmaller ones. And Bunny gave her back, in\nchange, two red petals from a rose.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Come again, Mrs. Anderson,” he called as\nSue, tucking her doll under one arm and her\npackages under the other, started away from\nthe play store. She walked across the grass\nand down toward the bushes that grew as a\nsort of hedge in front of the house.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("As she neared the gate, Sue saw something\nwhich caused her to cry out:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, look, Bunny! Look! Quick!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Say, didn’t I tell you I’m Mr. Gordon, the\ngrocer, and you mustn’t call me Bunny?”\ncried the little boy. “Now I’m not going to\nplay store any more!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I don’t want to play store!” exclaimed"), _c('span', {
    attrs: {
      "id": "Page_10",
      "title": "[Pg 10]"
    }
  }), _vm._v("\nSue, who was much excited. “Look, Bunny!\nIt’s a runaway horse and he’s coming right\nthis way!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("This made Bunny forget all about being a\ngrocer. Out from behind the counter he ran\nto join his sister near the gate. He saw, coming\ndown the street, a galloping horse on the\nback of which was a man who either had lost\nthe bridle or who did not know how to manage\nthe animal.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh, Sue, it is a runaway!” gasped Bunny,\nand for the first time since the store game had\nbegun he called his sister by her right name.\n“I wonder whose it is?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“I guess it’s that man’s,” said Sue. “Look!\nHe’s coming right for us! I’m going to run!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“He won’t come here!” said Bunny. “He\ncan’t jump over the bushes, Sue.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("The man on the back of the horse seemed\neither frightened or excited. He was now\nleaning forward, his arms around the neck of\nthe animal, and he cried:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Avast there! Belay! Drop your anchor!\nPull up at the dock! I want to go ashore!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    attrs: {
      "id": "Page_11",
      "title": "[Pg 11]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Bunny thought this was a funny way to talk\nto a horse.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“He should say ‘whoa’ or ‘back’ to him,”\nthought Bunny. “He’s talking just like\nBunker Blue or one of the sailors down at\ndaddy’s dock.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("But neither Bunny Brown nor his sister Sue\nhad time to think much more or do much\nmore. All of a sudden the horse came up on\nthe sidewalk near the Brown gate. Then, just\noutside the hedge of bushes, the horse came to\na sudden stop.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Off his back shot the man, up into the air,\nover the bushes in a curve, and then he fell to\nthe ground with a groan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("“Oh! Oh!” cried Bunny’s sister Sue.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0